var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"77104bc488248c0463b5dafc85d9ff2b060cf3ed"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["versum-web@versum-studios"]={id:"77104bc488248c0463b5dafc85d9ff2b060cf3ed"};
      